import React from "react";
import moment from "moment";
import { Callout } from "@blueprintjs/core";
import { Link } from "react-router-dom";

export default function BillingPeriod({ system, state, prefix }) {
  return (
    <>
      <p className="print-hide">
        {state.periods.map((month) => {
          if (month === state.period) {
            return (
              <strong key={month} style={{ margin: "0em .5em" }}>
                {month}
              </strong>
            );
          } else {
            return (
              <Link
                key={month}
                style={{ margin: "0em .5em" }}
                to={`/${prefix || "bill"}/${system}/${month}`}
              >
                {month}
              </Link>
            );
          }
        })}
      </p>
      <p>
        Billing period from {moment(state.times.start).format("LLLL")} to{" "}
        {moment(state.times.end).format("LLLL")}
      </p>
      {state.isFinalised && (
        <Callout intent='warning'>
          This billing period is finalised. No further changes can be made.
        </Callout>
      )}
    </>
  );
}
